<template>
  <div class="page-wrapper">
    <div class="row justify-between items-start">
      <div class="row justify-between">
        <h1>Транзакции</h1>
        <bonus-view/>
        <balance-view/>
      </div>
      <project-transaction-create
          @transactionCreated="$refs.projectTransactionsList.fetchTransactions()"
      />
    </div>
    <project-transactions-list
        ref="projectTransactionsList"
    />
  </div>
</template>

<script>
import ProjectTransactionsList from '../components/ProjectTransactions/ProjectTransactionsList'
import ProjectTransactionCreate from '../components/ProjectTransactions/ProjectTransactionCreate'
import BalanceView from './BalanceView'
import BonusView from './BonusView.vue'

export default {
  name: 'ProjectTransactionsView',

  components: {
    BalanceView,
    ProjectTransactionCreate,
    ProjectTransactionsList,
    BonusView,
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectTransactionsView.vue